import React from "react";

function SuccTickIcon() {
  return (
    <svg
      width="105"
      height="105"
      viewBox="0 0 105 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="7.5" y="7.5" width="90" height="90" rx="45" fill="#D1FADF" />
      <rect
        x="7.5"
        y="7.5"
        width="90"
        height="90"
        rx="45"
        stroke="#ECFDF3"
        strokeWidth="15"
      />
      <path
        d="M44.0625 52.5L49.6875 58.125L60.9375 46.875M71.25 52.5C71.25 62.8553 62.8553 71.25 52.5 71.25C42.1447 71.25 33.75 62.8553 33.75 52.5C33.75 42.1447 42.1447 33.75 52.5 33.75C62.8553 33.75 71.25 42.1447 71.25 52.5Z"
        stroke="#039855"
        strokeWidth="3.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SuccTickIcon;
